// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// export const adminAction = createAsyncThunk(
//   'admin/adminAction',
//   async ({ api, data, method = 'GET', token }, thunkAPI) => {
//     try {
//       const authToken = JSON.parse(localStorage.getItem('user_auth_token'))
//       const response = await fetch(api, {
//         method,
//         headers: {
//           'Content-Type': 'application/json',
//            Authorization: `Bearer ${authToken}`,
//         },
//         ...(data && { body: JSON.stringify(data) }),
//       });
//       const result = await response.json();
//       if (result?.status === false && result?.message === "Unauthorized"
//         && response.status === 401) {
//         localStorage.removeItem("user_auth_token"); // clear token
//         window.location.href = "/"; // redirect to login
//         return thunkAPI.rejectWithValue("Unauthorized, redirecting to login");
//       }

//       return result;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message || 'Something went wrong');
//     }
//   }
// );

// export const adminSlice = createSlice({
//     name :'admin',
//     initialState:{
//         data:{},
//         loading:false,
//         error:''
//     },
//     extraReducers: (builder) => {
//         builder.addCase(adminAction.pending, (state) => {
//             state.loading = true;
//         });
//         builder.addCase(adminAction.fulfilled, (state, action) => {
//             state.loading = false;
//             state.data = action.payload;
//         });
//         builder.addCase(adminAction.rejected, (state, action) => {
//             state.loading = false;
//             state.error = action.payload;
//         });
//     }
// });

// export default adminSlice.reducer



/// working code by ram
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const adminAction = createAsyncThunk(
  "admin/adminAction",
  async ({ api, data, method = "GET" }, thunkAPI) => {
    try {
      const authToken = JSON.parse(localStorage.getItem("user_auth_token"));

      const response = await fetch(api, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        ...(data && { body: JSON.stringify(data) }),
      });

      const result = await response.json();

      if (response.status === 401) {
        localStorage.removeItem("user_auth_token");
        window.location.href = "/";
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Something went wrong");
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(adminAction.rejected, (state, action) => {
        state.loading = false;
        state.data = null;
        state.error = action.payload;
      });
  },
});

export default adminSlice.reducer;
